import Head from "next/head";

export const createCanonicalHref = (baseUrl: string, uid: string) => {
  let HREF = baseUrl + "/";
  if (uid && uid !== "index") {
    if (uid.match("-college-credit")) {
      HREF = `${HREF}college-credit/${uid.replace("-college-credit", "")}`;
    } else {
      HREF = HREF + uid;
    }
  }
  return HREF;
};

export const CanonicalLink = function ({
  baseUrl,
  uid,
}: {
  baseUrl: string;
  uid: string;
}) {
  const HREF = createCanonicalHref(baseUrl, uid);

  return (
    <Head>
      <link rel="canonical" href={HREF} key="canonical" />
    </Head>
  );
};
